module.exports = __webpack_public_path__ + "img/Logo_new_year.c6ae9903.svg";